export default __webpack_public_path__ + "static/media/Floating-Properties_A1.e3af72ba.pdf";